/**
 * @file lib/case-doc-categories.ts
 * @description 案件文件分類定義（依新申請案件 SOP）。
 *
 * 在「新建案件精靈」與「案件詳情 → 關聯文件」彈窗共用，
 * 確保 case_documents.docType 字串一致，避免人工輸入造成標籤分散。
 *
 * key 即 case_documents.docType 的存庫值，請勿任意改名（已落庫資料以此 key 索引）。
 */

/** 單一分類設定 */
export interface CaseDocCategory {
  /** 對應 case_documents.docType，後端以此字串持久化 */
  key: string;
  /** UI 顯示文字 */
  label: string;
  /** 是否允許上傳多份（如「土地謄本」「資材單據」「其他」可多份） */
  multiple: boolean;
  /** 補充提示文字（可選），如「多筆土地時請提供」 */
  hint?: string;
}

/**
 * 新建案件精靈步驟 3 顯示的 11 類申請文件分類。
 *
 * 對應 SOP 「新申請案件派案流程說明」第 2 條：
 *   申請書／身分證或登記證明文件／存摺／栽培紀錄、L3／資材單據(農藥/肥料)／
 *   輪作計畫／土地謄本／租約或使用證明／土地清冊／集團管理手冊／其他文件
 */
export const CASE_DOC_CATEGORIES: CaseDocCategory[] = [
  { key: '申請書', label: '申請書', multiple: false },
  { key: '身分證或登記證明文件', label: '身分證或登記證明文件', multiple: false },
  { key: '存摺', label: '存摺', multiple: false },
  { key: '栽培紀錄、L3', label: '栽培紀錄、L3', multiple: true },
  { key: '資材單據(農藥/肥料)', label: '資材單據（農藥/肥料）', multiple: true },
  { key: '輪作計畫', label: '輪作計畫', multiple: false },
  { key: '土地謄本', label: '土地謄本', multiple: true },
  { key: '租約或使用證明', label: '租約或使用證明', multiple: true },
  { key: '土地清冊', label: '土地清冊', multiple: false, hint: '多筆土地時請提供' },
  { key: '集團管理手冊', label: '集團管理手冊', multiple: false },
  { key: '其他', label: '其他文件', multiple: true },
];

/**
 * 案件詳情頁手動「關聯文件」彈窗的 docType 下拉選項。
 *
 * 除 11 類申請文件外，再附加流程後續階段常用的「報價單」「繳費單」標籤，
 * 讓使用者補件時可直接選用統一字串。
 */
export const CASE_DOC_TYPE_OPTIONS: string[] = [
  ...CASE_DOC_CATEGORIES.map((c) => c.key),
  '報價單',
  '繳費單',
];
